/**
 * Read My Order Service
 * Migrated from 3in1cms legacy/readMyOrderApi.ts
 */

import { request } from "../core/request";
import { OPERATION_IDS, REST_CONNECTION_FROM } from "./constants";
import { createCacheAsync } from "@repo/shared-utils/cache";
// import { dataLayer } from "@repo/analytics/data-layer-utils";
import { generateCTLogData } from "@repo/shared-utils/easyEMIJourney";
import type { IReadMyOrderPayload } from "../types/easyEMIJourneyTypes";
import type { IReadMyOrderResponse } from "../types/readMyOrderTypes";

/**
 * Read my order data
 * @param reqData - Read my order payload
 * @returns Read my order response with order list
 */
export const readMyOrder = async (reqData: IReadMyOrderPayload): Promise<IReadMyOrderResponse> => {
  try {
    // dataLayer("", generateCTLogData("readMyOrder", "readMyOrderAPI Initiated"));

    const response = (await createCacheAsync(
      `${OPERATION_IDS.readmyorder}-${reqData.Mobile_Number}`,
      async () =>
        await request<IReadMyOrderResponse, IReadMyOrderPayload>({
          operationId: OPERATION_IDS.readmyorder,
          requestData: reqData,
          connectionFrom: REST_CONNECTION_FROM,
        })
    )) as IReadMyOrderResponse;

    // dataLayer("", generateCTLogData("readMyOrder", "readMyOrderAPI Success"));
    return response;
  } catch (error) {
    console.error("Error in readMyOrder", error);
    // dataLayer("", generateCTLogData("readMyOrder", "Error fetching read my order data"));
    return {
      myOrder: [],
      description: "Error fetching read my order data",
      statusCode: "7002",
    };
  } finally {
    // dataLayer("", generateCTLogData("readMyOrder", "readMyOrderAPI Finally Executed"));
  }
};
